import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';

export const sharedPolygonSources = {
    state: new VectorSource(),
    district: new VectorSource(),
    municipality: new VectorSource(),
};

export const sharedPointSources = {
    state: new VectorSource(),
    district: new VectorSource(),
    municipality: new VectorSource(),
};

export const makeDivisionWiseLayerGroup = ({sources, styles, zIndex, opacity}) =>
{
    return {
        state: new VectorLayer({
            source: sources.state,
            zIndex: zIndex,
            style: styles.state,
            opacity: opacity,
        }),
        district: new VectorLayer({
            source: sources.district,
            zIndex: zIndex + 0.1,
            style: styles.district,
            opacity: opacity,
        }),
        municipality: new VectorLayer({
            source: sources.municipality,
            zIndex: zIndex + 0.2,
            style: styles.municipality,
            opacity: opacity,
        }),
    };
};

export const setDivisionWiseLayerGroupOpacity = ({layerGroup, opacity}) =>
{
    const {state, district, municipality} = layerGroup;
    opacity = parseFloat(opacity);
    state.setOpacity(opacity);
    district.setOpacity(opacity);
    municipality.setOpacity(opacity);
};

export const setDivisionWiseLayerGroupVisible = ({layerGroup, visible}) =>
{
    const {state, district, municipality} = layerGroup;
    state.setVisible(visible);
    district.setVisible(visible);
    municipality.setVisible(visible);
};


export const setDivisionWiseLayerGroupZIndex = ({layerGroup, zIndex}) =>
{
    const {state, district, municipality} = layerGroup;
    state.setZIndex(zIndex);
    district.setZIndex(zIndex + 0.1);
    municipality.setZIndex(zIndex + 0.2);
};

// adding isCentroid property, this is used when linking it with the mapNavigator to add cenroid features
Object.values(sharedPointSources).forEach(src => src.set('isCentroid', true));